import { msg } from '@lit/localize';

const messages = () => ({
  firstName: {
    required: msg('First Name cannot be blank'),
  },
  lastName: {
    required: msg('Last Name cannot be blank'),
  },
  email: {
    email: msg('Invalid email address'),
    required: msg('Email address cannot be blank'),
  },
  jobRole: {
    required: msg('Job Role cannot be blank'),
  },
  partnerId: {
    required: msg('Partner ID cannot be blank'),
  },
  companyName: {
    required: msg('Company cannot be blank'),
  },
});

export default messages;
